import common from '../common'

export default {
    list(params) {
        return common.get('/rocheManage/system/sysDateConfig/list',params);
    },

    add(params) {
        return common.post('/rocheManage/system/sysDateConfig/add',params);
    },

    edit(params) {
        return common.put('/rocheManage/system/sysDateConfig/edit',params);
    },

    delete(params) {
        return common.delete('/rocheManage/system/sysDateConfig/delete',params);
    },
}


// WEBPACK FOOTER //
// ./src/api/sysmanagement/sysdateconfig.js